import { defineStyleConfig as o } from "@chakra-ui/react";
import { ThemeFontSizeVariable as a, ThemeSpaceVariable as e, ThemeColorVariable as i, ThemeFontVariable as t } from "../../theme-types.js";
const r = o({
  baseStyle: {
    width: "100%",
    fontFamily: t.Body,
    color: i.OnBackground,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: e.Small,
    gap: e.Medium,
    div: {
      button: {
        fontSize: a.Large
      }
    }
  }
});
export {
  r as paginatorConfig
};
